import dayjs from 'dayjs';
import { AssetCategory } from '../../../Utils/accountUtils';
import { analyticsStatusDataRefType } from '../../../Utils/types';
import { doesFiTypeExist } from './assetUtils';
import { defaultDateFormat } from '../BOB_V2/constants';

export type Holding = {
  companyName: string;
  bsePrices: number;
  units: number;
  isin: string;
  date: string;
  type: string;
  brokerName: string;
};

export const getTotalStockValue = (
  statusData: any,
  data: any,
  datafromAnalyticsStatus: React.RefObject<analyticsStatusDataRefType | null>
): number => {
  if (!doesFiTypeExist(AssetCategory.STOCKS, statusData)) {
    return 0;
  }
  return Math.round(
    (data as any)?.current?.EQUITIES_ETF?.data?.combinedOverallAnalysis
      ?.totalPortfolioValue ||
      Math.round(datafromAnalyticsStatus.current?.equities ?? 0) +
        Math.round(datafromAnalyticsStatus.current?.etf ?? 0)
  );
};

export const getListOfStocks = (statusData: any, stocksData: any) => {
  const accountFipMap = new Map(
    (statusData?.current?.accountDetails ?? []).map(
      ({ lastRawDataId, fipId, lastRawDataFetchedAt }: any) => [
        lastRawDataId,
        {
          fipId,
          lastRawDataFetchedAt,
        },
      ]
    )
  );

  const holdingMap = new Map<string, Holding>();

  (stocksData ?? []).forEach((stock: any) => {
    const accountDetails: any = accountFipMap.get(stock.dataRequestDetailsId);

    const modifiedStock = {
      ...stock,
      fipId: accountDetails?.fipId ?? null,
      lastRawDataFetchedAt: accountDetails?.lastRawDataFetchedAt ?? null,
    };
    const type = modifiedStock.rawData?.type?.toLowerCase() || 'equities';
    const stocksList =
      modifiedStock.rawData?.Summary?.Investment?.Holdings?.Holding ?? [];
    stocksList.forEach((h: any) => {
      const key = `${h.isin}_${type}`;
      if (holdingMap.has(key)) return;
      const ltp =
        type === 'etf'
          ? parseFloat(h.nav || '0')
          : parseFloat(h.lastTradedPrice || '0');

      holdingMap.set(key, {
        companyName: h.issuerName ?? h.isinDescription ?? '',
        bsePrices: ltp,
        units: parseFloat(h.units || '0'),
        isin: h.isin,
        date: dayjs(modifiedStock.lastRawDataFetchedAt).format(
          defaultDateFormat
        ),
        type,
        brokerName:
          modifiedStock.rawData.brokerName ?? modifiedStock.rawData.fipName,
      });
    });
  });

  return Array.from(holdingMap.values()).sort(
    (a, b) => b.bsePrices * b.units - a.bsePrices * a.units
  );
};

export const getStockBrokerHandler = (statusData: any, stocksData: any) => {
  const accountMap = new Map(
    statusData?.current?.accountDetails?.map((account: any) => [
      account.lastRawDataId,
      account.fipId,
    ]) || []
  );

  return stocksData?.map((stock: any) => ({
    ...stock,
    fipId: accountMap.get(stock.dataRequestDetailsId) ?? null,
  }));
};
